import lodash from 'lodash';

type ErrorType = {
  error?: string | undefined;
  details?: object | undefined;
  extra_info?: any;
} & Error;

type RedcatPaySaleFailureMessages = {
  refundFailedMessage: string;
  fallbackMessage: string;
};

export function isValidationError(e: ErrorType) {
  return [e.error, e.message].includes('Validation Error');
}

// Redcat Pay sale/finalise thunks reject with { e, ... } where e.details.json is the
// raw backend error body ({ details: { error_code }, message, ... }). Never surface
// e.message to the user — it's a raw backend string, not a UX-reviewed message.
export function getRedcatPaySaleFailureMessage(err: any, messages: RedcatPaySaleFailureMessages) {
  const errorCode = lodash.get(err, 'e.details.json.details.error_code');
  return errorCode === 'REFUND_FAILED' ? messages.refundFailedMessage : messages.fallbackMessage;
}

export function apiErrorToString(e: ErrorType) {
  if (isValidationError(e)) {
    return validationErrorToString(e);
  } else {
    let text =
      lodash.get(e, 'details.json.error') || lodash.get(e, 'message') || 'A problem has occurred';

    const additionalInfo = lodash.get(e, 'details.json.additional_info');

    if (typeof additionalInfo === 'string') {
      text = `${text}
      ${additionalInfo}`;
    }

    return text;
  }
}

export function validationErrorLineToString({ msg, path }: { msg: string; path: string[] }) {
  return `${msg} ${path && path.length ? `(${path.join(' > ')})` : ''}`;
}

export function validationErrorToString(e: ErrorType) {
  const info = lodash.get(e, 'details.json.extra_info') || lodash.get(e, 'extra_info') || [];

  const multiple = info.length > 1;

  if (!info || !info.length) {
    return 'Validation Error';
  }

  const top = `Validation Error${multiple ? 's' : ''}:`;

  const lines = info?.map(validationErrorLineToString);

  if (!multiple) {
    return `${top} ${lines[0]}`;
  }

  return [top, ...lines].join('\n');
}
